<script>
    import Tabs from "./Tabs.svelte";
    import MyTab from "./Tab.svelte";

    export let results = undefined;
    export let privateVersion = undefined;
    export let hasTrueInvoiceAmount = undefined;
    export let simAll = undefined;

    const columnHeaders = [
        ["Sans Mutuelle", "Sans Mutuelle", "Avec Mutuelle", "Avec Mutuelle"],
        ["pas de CP", "avec CP", "pas de CP", "avec CP"],
    ];

    const lineHeaders = [
        {
            key: "invoiceAmount",
            value: "Facturation",
        },
        {
            key: "dailyRate",
            value: "TJM",
        },
        {
            key: "totalBaseGross",
            value: "Salaire brut",
        },
        {
            key: "netToPayBeforePAS",
            value: "Salaire net",
        },
    ];

</script>

{#if simAll}
    <Tabs
            {results}
            {privateVersion}
            {hasTrueInvoiceAmount}
            {columnHeaders}
            {lineHeaders}
    />
{:else}
    <MyTab result={results[0]} {privateVersion} check="z" />
{/if}